import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
export default Helper.extend({
  sqIntl: service(),
  compute([key], params) {
    return this.sqIntl.t(key, params);
  }
});